module.exports = __webpack_public_path__ + "img/thumb-josh-hidayat.d44f2119.png";